import { useRoute } from "wouter"

import { TimetableStoreProvider } from "../timetable/lib/useTimetableStore"

import AnnouncementsContent from "./AnnouncementsContent"

export default function Announcements() {
  const [match, params] = useRoute("/announcements/:locationId/:roomIds")

  if (!match) {
    return null
  }

  return (
    <TimetableStoreProvider
      locationId={params.locationId}
      roomNumbers={params.roomIds.split(",").map((val) => parseInt(val))}>
      {(): React.JSX.Element => {
        return <AnnouncementsContent />
      }}
    </TimetableStoreProvider>
  )
}
